import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { OfficeList, OfficeListResponse } from '../models/officelist.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';


@Injectable()
export class OfficeService {
    private baseUrl: string;
    private api: string = "api/Office";
    
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Office Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

  async getOfficeListAsync(encryptedUser: string, clpUserId: number): Promise<OfficeListResponse | void> {
    const a = await this.httpClient
      .get<OfficeListResponse>(`${this.baseUrl}/GetOfficeListByUserId/${clpUserId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "clpUserId - " + clpUserId, encryptedUser, "OfficeService", "getOfficeListAsync"); });

    return a;
  }
}
